import { useState, useEffect, useRef } from "react";
import { Modal, ModalBody, FormGroup, Label, Input } from "reactstrap";
import { GrFormClose } from "react-icons/gr";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { listGurudwaras } from "../Header/Data";
import {
  fetchMyGurdwaraBookings,
  resetGurdwara,
  setGurdwaras,
} from "../../redux/slices/GurdwaraSlice";

const SelectGurdwaraModal = ({
  isOpen,
  toggleModal,
  gurdwaraId,
  setGurdwaraId,
  gurdwaraName,
  setGurdwaraName,
}) => {
  //   const [gurdwaras, setGurdwaras] = useState([]);
  const { gurdwaras } = useSelector((state) => state.gurdwara);
  const dispatch = useDispatch();
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = userinfo ? JSON.parse(userinfo) : null;
  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );
  const { myGuruBookingList } = useSelector((state) => state.gurdwara);

  let myLatestGuruBooking =
    myGuruBookingList &&
    myGuruBookingList.filter(
      (item) =>
        (item.paymentStatus == "PENDING" || item.paymentStatus == null) &&
        item.gurudwaraId == gurdwaraId
    )[0];

  const hasFetched = useRef(false);

  useEffect(() => {
    const fetchGurdwara = async () => {
      if (hasFetched.current) return;
      hasFetched.current = true;
      const gurudwaras = await listGurudwaras();
      dispatch(setGurdwaras(gurudwaras));
    };
    fetchGurdwara();
  }, []);

  const handleClick = (e) => {
    const selectedValue = e.target.value;
    const selectedGurdwaraData = gurdwaras.find(
      (gurudwara) => gurudwara.Id === parseInt(selectedValue)
    );
    setGurdwaraId(selectedValue);
    setGurdwaraName(selectedGurdwaraData ? selectedGurdwaraData.Title : "");
    dispatch(fetchMyGurdwaraBookings(user?.UserID));
  };

  const handleSubmit = () => {
    // if (!isProfileComplete) {
    //   toast.info("Please complete your profile.");
    //   return;
    // }
    const cleanedGurdwaraName = gurdwaraName.replace(/\s+/g, "");
    if (cleanedGurdwaraName === "") {
      toast.error("Please select Gurdwara");
      return;
    }
    if (myLatestGuruBooking) {
      Swal.fire({
        title: `Do you want to finish the booking inquiry you started with ${gurdwaraName}?`,
        confirmButtonText: "Yes, continue",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.setItem(
            "myLatestGuruBooking",
            JSON.stringify(myLatestGuruBooking)
          );
          localStorage.setItem("editType", "GURDWARA_ADMIN");
          window.open(
            `/#/bookGurdwara/${cleanedGurdwaraName}/Fill-your-Info?id=${gurdwaraId}`,
            "_blank",
            "noopener,noreferrer"
          );
        }
      });
    } else {
      localStorage.removeItem("myLatestGuruBooking");
      localStorage.removeItem("editType");
      window.open(
        `/#/bookGurdwara/${cleanedGurdwaraName}/Fill-your-Info?id=${gurdwaraId}`,
        "_blank",
        "noopener,noreferrer"
      );
      dispatch(resetGurdwara());
    }
    toggleModal();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalBody>
        <div className="d-flex justify-content-between">
          <h5 className="mt-2">Select Gurdwara</h5>
          <h5 className="btn btn-sm" onClick={toggleModal}>
            <GrFormClose size={30} />
          </h5>
        </div>
        <FormGroup>
          {/* <Label for="gurdwaraSelect">Choose a Gurdwara</Label> */}
          <Input
            type="select"
            name="gurdwara"
            id="gurdwaraSelect"
            value={gurdwaraId || ""}
            onChange={handleClick}
          >
            <option value="0">Select Gurdwara</option>
            {gurdwaras.map((gurudwara) => (
              <option key={gurudwara.Id} value={gurudwara.Id}>
                {gurudwara.Title}
              </option>
            ))}
          </Input>
        </FormGroup>
        <div className="d-flex justify-content-end gap-10">
          <button className="btn btn-sm btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SelectGurdwaraModal;
